import React from "react";
import { useTranslation } from "react-i18next";
import { Input } from "components/bootstrap";
const WhoisAdapterFieldSet = ({ config, handleFormEvent, validationMessage, validationState }) => {
  const { t } = useTranslation("integrations");
  /* @__PURE__ */ React.createElement("fieldset", null, /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "number",
      id: "connect_timeout",
      name: "connect_timeout",
      label: t("whois_adapter_field_set.connect_timeout_label"),
      required: true,
      onChange: handleFormEvent,
      help: validationMessage("connect_timeout", t("whois_adapter_field_set.connect_timeout_help")),
      bsStyle: validationState("connect_timeout"),
      value: config.connect_timeout,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ), /* @__PURE__ */ React.createElement(
    Input,
    {
      type: "number",
      id: "read_timeout",
      name: "read_timeout",
      label: t("whois_adapter_field_set.read_timeout_label"),
      required: true,
      onChange: handleFormEvent,
      help: validationMessage("read_timeout", t("whois_adapter_field_set.read_timeout_help")),
      bsStyle: validationState("read_timeout"),
      value: config.read_timeout,
      labelClassName: "col-sm-3",
      wrapperClassName: "col-sm-9"
    }
  ));
};
export default WhoisAdapterFieldSet;
